import Swiper from 'swiper';
import { Navigation, Pagination, Keyboard, Autoplay, EffectFade } from 'swiper/modules';

// Import Swiper and modules styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/keyboard';
import 'swiper/css/autoplay';
import 'swiper/css/effect-fade';

new Swiper('.js-traits .swiper', {
    modules: [Keyboard, Navigation, Autoplay], // configure Swiper to use modules
    centerInsufficientSlides: true,
    rewind: true,
    loop: true,
    slidesPerView: 2,
    spaceBetween: 64,
    autoplay: {
        delay: 2000,
    },
    disableOnInteraction: false,
    keyboard: {
        enabled: true,
    },
    speed: 700,
    grabCursor: true,
    navigation: {
        nextEl: '.js-traits .swiper-button-next',
        prevEl: '.js-traits .swiper-button-prev',
    },
    breakpoints: {
        640: {
            slidesPerView: 3,
        },
        1024: {
            slidesPerView: 4,
        },
        1280: {
            slidesPerView: 5,
            spaceBetween: 80,
        },
        1440: {
            slidesPerView: 6,
            spaceBetween: 96,
        },
    },
});

new Swiper('.js-testimonials .swiper', {
    modules: [Navigation, Keyboard, Autoplay, EffectFade], // configure Swiper to use modules
    autoplay: {
        delay: 16000,
    },
    disableOnInteraction: false,
    effect: 'fade',
    fadeEffect: {
        crossFade: true,
    },
    grabCursor: true,
    loop: true,
    pauseOnMouseEnter: true,
    slidesPerView: 1,
    speed: 700,
    navigation: {
        nextEl: '.js-testimonials .swiper-button-next',
        prevEl: '.js-testimonials .swiper-button-prev',
    },
});

document.addEventListener('DOMContentLoaded', () => {
    if (document.querySelector('.timeline-section .swiper-timeline')) {
        // Initialize Swiper for timeline
        const timelineSwiper = new Swiper('.timeline-section .swiper-timeline', {
            modules: [Navigation, Pagination, Keyboard, Autoplay, EffectFade],
            effect: 'fade',
            rewind: true,
            loop: true,
            slidesPerView: 1,
            autoplay: {
                delay: 3000,
            },
            disableOnInteraction: false,
            keyboard: {
                enabled: true,
            },
            fadeEffect: {
                crossFade: true,
            },
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            pagination: {
                el: '.swiper-pagination',
                clickable: true,
                dynamicBullets: true,
                renderBullet: function (index, className) {
                    // Adjust the index to wrap around correctly for looping
                    const slides = this.slides.length;
                    const slideIndex = (index % slides) + (index < 0 ? slides : 0);
                    const yearSlide = document.querySelector(
                        '.swiper-slide[data-swiper-slide-index="' + slideIndex + '"]',
                    );
                    const year = yearSlide ? yearSlide.getAttribute('data-year') : '';
                    return (
                        '<span class="' +
                        className +
                        ' w-fit h-fit rounded-none bg-transparent text-forum-text text-xl leading-[120%] mx-3 lg:mx-4 xl:mx-6 xl:text-2xl">' +
                        year +
                        '</span>'
                    );
                },
            },
            breakpoints: {
                768: {
                    pagination: {
                        dynamicMainBullets: 2,
                    },
                },
                1024: {
                    pagination: {
                        dynamicMainBullets: 4,
                    },
                },
                1280: {
                    pagination: {
                        dynamicMainBullets: 6,
                    },
                },
            },
        });

        // Handle window resize to update pagination
        window.addEventListener('resize', () => {
            timelineSwiper.update();
            setTimeout(() => {
                timelineSwiper.pagination.render();
                timelineSwiper.pagination.update();
            }, 300); // Delay to ensure the layout settles before updating pagination
        });
    }
});

new Swiper('.js-downloads .swiper', {
    modules: [Keyboard, Navigation], // configure Swiper to use modules
    centerInsufficientSlides: true,
    rewind: true,
    loop: true,
    slidesPerView: 2,
    spaceBetween: 16,
    speed: 700,
    grabCursor: true,
    navigation: {
        nextEl: '.js-downloads .swiper-button-next',
        prevEl: '.js-downloads .swiper-button-prev',
    },
    breakpoints: {
        640: {
            slidesPerView: 3,
        },
        1024: {
            slidesPerView: 4,
        },
        1280: {
            slidesPerView: 5,
            spaceBetween: 20,
        },
        1920: {
            slidesPerView: 6,
            spaceBetween: 20,
        },
    },
});

new Swiper('.js-featured .swiper', {
    modules: [Keyboard, Navigation, Autoplay, EffectFade], // configure Swiper to use modules
    autoplay: {
        delay: 16000,
    },
    disableOnInteraction: false,
    effect: 'fade',
    fadeEffect: {
        crossFade: true,
    },
    grabCursor: true,
    navigation: {
        nextEl: '.js-featured .swiper-button-next',
        prevEl: '.js-featured .swiper-button-prev',
    },
    loop: true,
    pauseOnMouseEnter: true,
    slidesPerView: 1,
    speed: 700,
});
